module.exports = __webpack_public_path__ + "img/banner.f5ee25df.jpg";